import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const STUDIO_ID = "svc-engineering-studio";

// Approve / reject several Engineering Studio drafts at once
export function StudioBulkBar({ codes, ignored = 0, onDone }) {
  const [busy, setBusy] = useState(false);
  if (!codes.length && !ignored) return null;
  const run = async (ok) => {
    const comment = ok ? "" : window.prompt(`Reason for rejecting ${codes.length} Engineering Studio draft(s)?`);
    if (!ok && !comment) return;
    if (ok && !window.confirm(`Approve ${codes.length} Engineering Studio draft(s)? They become ACTIVE items.`)) return;
    setBusy(true);
    try {
      const r = await api.post("/items/bulk-decision", { codes, decision: ok ? "approved" : "rejected", comment });
      const { done, skipped } = r.data;
      toast.success(`${done.length} ${ok ? "approved" : "rejected"}${skipped.length ? ` · ${skipped.length} skipped` : ""}`);
      skipped.slice(0, 5).forEach((s) => toast.warning(`${s.code}: ${s.reason}`));
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <span className="flex flex-wrap items-center gap-2" data-testid="studio-bulk-bar">
      <span className="text-xs text-slate-600" data-testid="studio-bulk-count">{codes.length} Engineering Studio draft(s) ticked{ignored ? ` · ${ignored} other ticked item(s) ignored` : ""}</span>
      <Button size="sm" className="h-7" disabled={busy || !codes.length} onClick={() => run(true)} data-testid="studio-bulk-approve">Approve {codes.length}</Button>
      <Button size="sm" variant="outline" className="h-7 text-red-600" disabled={busy || !codes.length} onClick={() => run(false)} data-testid="studio-bulk-reject">Reject {codes.length}</Button>
    </span>
  );
}
